import React from "react";
import { useNavigate } from "react-router-dom";
import "./CardContainer.css"; // Ensure you're importing your CSS

const CardContainer = ({ onCardClick }) => {
  return (
    <div className="card-container">
      <div className="card" onClick={onCardClick}>
        <img
          src="/shooting-maria/feature-1.jpg"
          alt="Card 1"
          className="card-image"
        />
        <div className="card-description">
          Descoperă produsele <span className="arrow-tip">&#x3E;</span>
        </div>
      </div>
      <div className="card" onClick={onCardClick}>
        <img
          src="/shooting-maria/feature-2.jpg"
          alt="Card 2"
          className="card-image"
        />
        <div className="card-description">
          Descoperă produsele <span className="arrow-tip">&#x3E;</span>
        </div>
      </div>
      <div className="card" onClick={onCardClick}>
        <img
          src="/shooting-maria/feature-3.jpg"
          alt="Card 3"
          className="card-image"
        />
        <div className="card-description">
          Descoperă produsele <span className="arrow-tip">&#x3E;</span>
        </div>
      </div>
    </div>
  );
};

export default CardContainer;
